import PackingList from './packing-list-container';

export default PackingList;